import { UPDATE_FILE_STATE } from '../constants/fileStateConstants';

export function updateFileState(needSave) {
    return {
        type: UPDATE_FILE_STATE,
        payload: { needSave }
    };
}